import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {Scan3dModel} from '../../../api/entity/scan3d.model';
import {Scan3dConverter} from '../../../api/entity/converter/scan3d.converter';

@Injectable()
export class Scan3dDataService extends AbstractDataServiceV2<Scan3dModel, Scan3dConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: Scan3dConverter) {
        super('Scan3d', http, httpUrlGenerator, logger, config, converter);
    }
}
